import { useState } from 'react';
import classnames from 'classnames';
import { InlineAlertProps } from './types';
import IconClose from '@scramble/design-system/icons/x-close.svg';
import IconNeutral from '@scramble/design-system/icons/bookmark.svg?react';
import IconInfo from '@scramble/design-system/icons/info-circle.svg?react';
import IconSuccess from '@scramble/design-system/icons/check-circle.svg?react';
import IconDanger from '@scramble/design-system/icons/alert-circle.svg?react';
import IconWarning from '@scramble/design-system/icons/alert-triangle.svg?react';
import s from './index.module.scss';

const ICONS = { neutral: IconNeutral, info: IconInfo, success: IconSuccess, danger: IconDanger, warning: IconWarning };

export const InlineAlert = ({ type = 'info', icon, title, message, canClose, className, onClose }: InlineAlertProps) => {
  const [open, setOpen] = useState(true);

  const Icon = ICONS[type];

  const handleClose = () => {
    onClose && onClose();
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className={classnames(s.wrapper, type, className)}>
      <div className={classnames(s.icon, type)}>{icon || (Icon && <Icon />)}</div>
      <div className={s.content}>
        {title && <div className="f-body-sm f-500">{title}</div>}
        {message && <div className="f-body-sm">{message}</div>}
      </div>
      {(canClose || onClose) && (
        <button type="button" className={s.btn_close} onClick={handleClose}>
          <img src={IconClose} alt="close" width={16} height={16} />
        </button>
      )}
    </div>
  );
};
